import { Box } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import React from 'react';
import { SwyftPopover, SwyftPopoverContent } from './Popover';

export const ActionList = ({ children }: { children: (onClose: () => void) => React.ReactNode }) => (
  <SwyftPopover>
    <Box textAlign='center'>
      <MoreVert color='primary' style={{ cursor: 'pointer' }} />
    </Box>
    <SwyftPopoverContent>{(onClose) => <Box py={2}>{children ? children(onClose) : null}</Box>}</SwyftPopoverContent>
  </SwyftPopover>
);
